var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8064)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 0.976562H0.976562V49.0234H49.0234V0.976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5893 21.6221C29.3207 20.1614 28.2404 11.5156 21.7433 12.6774C16.3062 13.6495 17.8371 23.7067 24.5893 21.6221Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4681 29.9578C28.9477 30.9204 21.9308 36.1499 22.9628 36.8696C24.7368 35.635 31.5561 29.8828 29.4681 29.9578Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9749 24.0628C34.5518 24.339 34.6791 26.5851 35.7716 26.9088C38.3112 27.6607 38.5773 23.5576 35.9749 24.0628Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0.976562C11.7321 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7321 49.0234 25 49.0234C38.2679 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2677 0.976562 25 0.976562ZM12.1901 34.6331C12.3837 27.8538 9.97334 21.9926 17.9839 21.7243C14.1871 17.5781 17.1887 10.5676 22.7611 10.4418C28.5697 10.3106 31.835 17.3489 27.945 21.7243L29.7746 22.1309C29.3341 22.7068 28.8937 23.2827 28.4532 23.8588C26.7527 24.6028 15.16 22.2177 14.3247 25.79V32.499L17.2724 32.6007C17.3063 31.2791 17.3402 29.9577 17.374 28.6365L18.8987 28.5349C18.9326 29.8565 18.9665 31.1779 19.0004 32.499L22.6596 32.7023L20.525 34.6336L12.1901 34.6331ZM39.9391 29.246C39.0001 31.1938 35.4383 33.0753 33.5354 31.7871C31.2529 34.3677 29.5305 33.1152 29.0628 33.4134C29.0289 33.8539 28.995 34.2943 28.9611 34.7348L27.6397 34.8364C27.572 35.243 27.5043 35.6496 27.4364 36.0562H26.2167C26.0669 36.1517 26.3975 38.0815 24.997 38.6989C23.0123 39.5739 20.6358 38.2519 21.0328 36.7677L29.7742 28.2296C28.9033 25.5304 30.861 22.0592 33.7384 21.6228C38.2148 20.9436 41.9896 24.9919 39.9387 29.2461",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateToken);
export default __webpack_public_path__ + "static/media/generate_token.94ddc81fa2e560ecfbef4b42aa56267d.svg";
export { ForwardRef as ReactComponent };